import FreeSpinReel from "./FreeSpinReel";
import ResourcesDispatcher from "../../config/ResourcesDispatcher";
export default class FreeSpinReelStatic extends FreeSpinReel {
    constructor(x, y, index, freeSpinCellCreation) {
        super(x, y, index, freeSpinCellCreation);
    }
    configureFreeSpinTween() {
        this.resetFlagsAndCounters();
        this.spinProgress = scene.tweens.add({
            targets: this.spinProgressValue,
            ease: "Linear",
            value: { from: 0, to: this.cellSize.height },
            paused: true,
            loop: -1,
            delay: 0,
            yoyo: false,
            duration: this.spinAnimationDuration,
            onStart: () => {
                this.freeSpinCells.forEach(cell => {
                    cell.resetLayer();
                });
                this.turnOn();
            },
            onUpdate: () => {
                if (this.stopped) {
                    return;
                }
                this.freeSpinCells.forEach((cell) => {
                    // Position
                    cell.getContainer().y = this.cellPosition[cell.getIndex()].y + this.spinProgressValue.value;
                });
            },
            onLoop: () => {
                if (this.stopped) {
                    return;
                }
                this.virtualReelPosition = (this.virtualReelPosition + 1) % scene.freeSpinGameArea.virtualGrid[this.index].length;
                scene.freeSpinGameArea.increaseLoopCounter(this.index);
                this.reIndexCells();
                if (this.mustStop) {
                    this.freeSpinCells[0].setCellInfo(gameDataManager.getOutGridCellsUp()[this.index]);
                    this.freeSpinCells[this.lastCellIndex].setCellInfo(gameDataManager.getOutGridCellsDown()[this.index]);
                    // Real memo
                    for (let i = 1; i < this.lastCellIndex; i++) {
                        const realmemo = gameDataManager.getGrid()[this.index * this.numOfCellsPerReel + (i - 1)];
                        this.freeSpinCells[i].setCellInfo(realmemo);
                    }
                    this.spinProgress.stop();
                    this.bounce();
                }
                else if (!this.canStop) { // Fake memo
                    const xmemo = scene.freeSpinGameArea.virtualGrid[this.index][this.virtualReelPosition];
                    this.freeSpinCells[this.lastCellIndex].setCellInfo(xmemo);
                }
                else if (this.canStop) {
                    if (this.realMemoIndex === 0) { // Invisible cell
                        this.freeSpinCells[this.lastCellIndex].setCellInfo(gameDataManager.getOutGridCellsDown()[this.index]);
                    }
                    else if (this.realMemoIndex < this.lastCellIndex) { // Visible cell, real memo
                        const realmemo = gameDataManager.getGrid()[this.index * this.numOfCellsPerReel + (this.realMemoIndex - 1)];
                        this.freeSpinCells[this.lastCellIndex].setCellInfo(realmemo);
                    }
                    else if (this.realMemoIndex === this.lastCellIndex) { // Invisible cell, fake memo with SCATTER and WILD check, stop spin
                        this.freeSpinCells[this.lastCellIndex].setCellInfo(gameDataManager.getOutGridCellsUp()[this.index]);
                        this.spinProgress.stop();
                        this.bounce();
                    }
                    this.realMemoIndex++;
                }
            }
        });
    }
    bounce() {
        if (this.stopped) {
            return;
        }
        this.bounceTween1 = scene.tweens.add({
            targets: this.spinProgressValue,
            ease: "Linear",
            value: { from: 0, to: this.cellSize.height * 0.75 },
            yoyo: false,
            duration: this.spinAnimationDuration * 0.75,
            onStart: () => {
                this.stopped = true;
            },
            onUpdate: () => {
                this.freeSpinCells.forEach((cell) => {
                    cell.getContainer().y = this.cellPosition[cell.getIndex()].y + this.spinProgressValue.value;
                });
            },
            onComplete: () => {
                soundManager.play(ResourcesDispatcher.SOUNDS.SOUND_REELS_STOP);
                // Turbo on(low volume) or forced stop
                if (gameLogicVariableManager.getTurbo() || this.mustStop) {
                    // TODO: add stop sound
                }
                else {
                    let specificSound = false;
                    if (gameLogicVariableManager.getCurrentGameMode() === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.FREEGAME) {
                        // if there is a multiplier in the reel, play the sound
                        specificSound = this.freeSpinCells.some(cell => cell.getMemo() > 0 && cell.getIndex() > 0 && cell.getIndex() < (this.lastCellIndex));
                    }
                }
                this.bounceTween2 = scene.tweens.add({
                    targets: this.spinProgressValue,
                    ease: "Power0",
                    value: { from: this.cellSize.height * 0.75, to: 0 },
                    yoyo: false,
                    duration: this.spinAnimationDuration * 6,
                    //TODO implementare ONSTART
                    onUpdate: () => {
                        this.freeSpinCells.forEach((cell) => {
                            cell.getContainer().y = this.cellPosition[cell.getIndex()].y + this.spinProgressValue.value;
                        });
                    },
                    onComplete: () => {
                        this.freeSpinCells.forEach((cell) => {
                            cell.checkLayer();
                        });
                        scene.time.addEvent({
                            delay: 150,
                            callback: () => {
                                scene.freeSpinGameArea.notifySpinCompleted(this.index);
                            },
                        });
                    }
                });
                if (this.spinMainButtonTween && this.spinMainButtonTween.isPlaying()) {
                    this.spinMainButtonTween.stop();
                    window.isButtonSpinning = false;
                }
            }
        });
    }
}
